module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "cop"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_vm._v("Copyright © 2013 by Shauna James Ahern and Daniel Ahern. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Photography Copyright © 2013 by Penny De Los Santos")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cover design by Suzanne Sunwoo")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cover image by Penny De Los Santos")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Interior design by Kara Plikaitis")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Food styling by Karen Shinto")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Prop styling by Anne Trenner-Mishka")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Published by Houghton Mifflin Harcourt Publishing Company, New York, New York")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Published simultaneously in Canada.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "http://www.hmhbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _c('br'), _vm._v("\nAhern, Shauna James."), _c('br'), _vm._v("\nGluten-free girl every day / Shauna James Ahern, with Daniel Ahern; photography by Penny De Los Santos."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "crt2"
  }, [_vm._v("p. cm.")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "crt1"
  }, [_vm._v("ISBN 978-1-118-11521-3 (cloth); 978-0-544-18659-0 (ebk)")]), _c('br'), _vm._v("\n1. Gluten-free diet--Recipes. I. Ahern, Daniel, 1968- II. Title."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "crt1"
  }, [_vm._v("RM237.86.A339 2013")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "crt1"
  }, [_vm._v("641.5’638--dc23")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "crt3"
  }, [_vm._v("2012030520")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("v1.0413")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bede684","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/cop.vue
// module id = 66
// module chunks = 0